module.exports = __webpack_public_path__ + "img/icon_fast_delivery.62fc092.svg";